export default __webpack_public_path__ + "static/media/logo-agrisud-cropped2.ea8389a4.jpg";